import { ProjectChallenges } from '../../../__generated__/graphql';

export type UserType = "homeowner" | "business";

export type ProjectType =
  | "one-off"
  | "short-term-contract"
  | "long-term-ongoing";

export type ProjectManagementType =
  | "laborhack-managed"
  | "shared-management"
  | "self-managed";

// User type options for radio buttons
export const USER_TYPE_OPTIONS = [
  {
    value: "homeowner" as UserType,
    label: "Homeowner",
    description: "Individual looking to outsource personal projects",
  },
  {
    value: "business" as UserType,
    label: "Business",
    description: "Company or organization seeking project outsourcing",
  },
];

// Project type options
export const PROJECT_TYPE_OPTIONS = [
  {
    value: "one-off" as ProjectType,
    label: "One-off Project",
    description: "Single, standalone project",
  },
  {
    value: "short-term-contract" as ProjectType,
    label: "Short-term Contract",
    description: "3-6 months duration",
  },
  {
    value: "long-term-ongoing" as ProjectType,
    label: "Long-term/Ongoing",
    description: "6+ months or recurring work",
  },
];

// Project management type options
export const PROJECT_MANAGEMENT_OPTIONS = [
  {
    value: "laborhack-managed" as ProjectManagementType,
    label: "LaborHack Managed",
    description: "Full project management by LaborHack team",
  },
  {
    value: "shared-management" as ProjectManagementType,
    label: "Shared Management",
    description: "Collaborative management between you and LaborHack",
  },
  {
    value: "self-managed" as ProjectManagementType,
    label: "Self Managed",
    description: "You manage the project directly",
  },
];

// Project challenges options for multi-select
export const PROJECT_CHALLENGES_OPTIONS = [
  {
    value: ProjectChallenges.DelaysInDelivery,
    label: "Delays in Delivery",
    description: "Avoid projects that may have timeline issues",
  },
  {
    value: ProjectChallenges.PoorQualityWork,
    label: "Poor Quality Work",
    description: "Ensure high standards and quality output",
  },
  {
    value: ProjectChallenges.PoorCommunication,
    label: "Poor Communication",
    description: "Prioritize clear and regular communication",
  },
  {
    value: ProjectChallenges.UnverifiedSkillsOrQualifications,
    label: "Unverified Skills or Qualifications",
    description: "Ensure professionals have verified credentials",
  },
  {
    value: ProjectChallenges.BudgetOverruns,
    label: "Budget Overruns",
    description: "Avoid projects that exceed planned budget",
  },
];

// Special option for "Other" challenges - used to trigger text input
export const OTHER_CHALLENGES_OPTION = {
  value: "OTHER" as const,
  label: "Other",
  description: "Specify custom challenges not listed above",
};

// Industry options for business users
export const INDUSTRY_OPTIONS = [
  "Technology",
  "Healthcare",
  "Finance",
  "Education",
  "Manufacturing",
  "Retail",
  "Construction",
  "Real Estate",
  "Marketing & Advertising",
  "Consulting",
  "Non-profit",
  "Government",
  "Other",
];
